import { render, staticRenderFns } from "./bigDetail.vue?vue&type=template&id=6502b956&scoped=true"
import script from "./bigDetail.vue?vue&type=script&lang=js"
export * from "./bigDetail.vue?vue&type=script&lang=js"
import style0 from "./bigDetail.vue?vue&type=style&index=0&id=6502b956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502b956",
  null
  
)

export default component.exports